import { render, staticRenderFns } from "./ShiftPatternSetup.vue?vue&type=template&id=a6b1654c&scoped=true&"
import script from "./ShiftPatternSetup.vue?vue&type=script&lang=ts&"
export * from "./ShiftPatternSetup.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftPatternSetup.vue?vue&type=style&index=0&id=a6b1654c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1654c",
  null
  
)

export default component.exports